import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle } from "react";
import { useFormik, FormikProvider } from "formik";
import { useNavigate } from "react-router-dom";
import ToastDialog from "components/Common/ToastDialog";
import JoditEditor from "jodit-react";
import { addDealTermsheet, getOneDeal, saveTermsheet } from "http/fundLync/deal.helper";
import * as Yup from "yup";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Button,
  Label,
} from "reactstrap";
import { decryptedValue } from "common/utility";
import PropTypes from "prop-types";
import { addCamData, editCamData, getCamData } from "http/fundLync/cam.helper";

const EntityTermsheet = forwardRef((props, ref) => {
  document.title = "Termsheet | FundLync"
  const { queryString } = props; 
  const navigate = useNavigate();
  // const [dealId, setDealId] = useState("");
  const [dealDetails, setDealDetails] = useState({});
  const [content, setContent] = useState("");
  const [template, setTemplate] = useState("");
  const editor = useRef(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [toastInfo, setToastInfo] = useState({
    message: "",
    showToast: false,
    role: "",
  });

  const urlParams = new URLSearchParams(window.location.search);
  const encodedDealId = urlParams.get("dealId");
  const encodedId = urlParams.get("id");
  const entityId = atob(encodedId)
  const dealId = atob(encodedDealId)
  const [camData, setCamData] = useState([])

  useEffect(() => {
    if (encodedDealId) {
      const decodedDealId = atob(encodedDealId);
      getCamData({ dealId })
        .then((response) => {
          if (response) {
            setCamData([response?.data[0]]);
            const data = response?.data[0]
            if (response?.status && data?.termsheet != null) {
              setContent(data?.termsheet);
            } else {
              getOneDeal({ id: decodedDealId })
                .then((response) => {
                  if (response) {
                    setDealDetails(response);
                  }
                })
                .catch((error) => {
                  console.error("Error fetching deal:", error);
                });

              setContent(template);
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching deal:", error);
        });
    }
  }, [encodedDealId, template]);

  useEffect(() => {
    if (Object.keys(dealDetails).length === 0) return;
    const initialHtmlWC =
      `
    <div class="OutlineElement Ltr SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; clear: both; cursor: text; overflow: visible; position: relative; direction: ltr; color: rgb(0, 0, 0); font-family: &quot;Segoe UI&quot;, &quot;Segoe UI Web&quot;, Arial, Verdana, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; font-size: 12px;">
        <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 10px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span data-contrast="none" xml:lang="EN-US" lang="EN-US" class="TextRun Underlined SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; color: rgb(0, 0, 0); line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; font-weight: bold; font-variant-ligatures: none !important; font-size: 11pt;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">${dealDetails?.dealProductCommercials[0].product} - Term Sheet: </span></span><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 11pt;"><br></span></p>
        <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 10px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 11pt;"><br></span></p>
        ${commonTableHTML}
    </div>
    `

    const initialHtmlRP = `
      <div class="OutlineElement Ltr SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; clear: both; cursor: text; overflow: visible; position: relative; direction: ltr; color: rgb(0, 0, 0); font-family: &quot;Segoe UI&quot;, &quot;Segoe UI Web&quot;, Arial, Verdana, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal; background-color: rgb(255, 255, 255); text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial; font-size: 12px;">
        <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 10px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span data-contrast="none" xml:lang="EN-US" lang="EN-US" class="TextRun Underlined SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; color: rgb(0, 0, 0); line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; font-weight: bold; font-variant-ligatures: none !important; font-size: 11pt;"><span class="NormalTextRun SCXW91584501 BCX0" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text;">${dealDetails?.dealProductCommercials[0].product} - Term Sheet: </span></span><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 11pt;"><br></span></p>
        <p class="Paragraph SCXW91584501 BCX0" paraid="383431057" paraeid="{92348b89-550b-460e-b6d0-969d803a9340}{8}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px -1px 0px 10px; padding: 0px; user-select: text; overflow-wrap: break-word; white-space: pre-wrap; font-weight: normal; font-style: normal; vertical-align: baseline; font-kerning: none; background-color: transparent; color: windowtext; text-align: left; text-indent: 0px;"><span class="EOP SCXW91584501 BCX0" data-ccp-props="{&quot;201341983&quot;:0,&quot;335551550&quot;:6,&quot;335551620&quot;:6,&quot;335559685&quot;:-567,&quot;335559737&quot;:-13,&quot;335559739&quot;:0,&quot;335559740&quot;:240}" style="-webkit-user-drag: none; -webkit-tap-highlight-color: transparent; margin: 0px; padding: 0px; user-select: text; line-height: 18px; font-family: Calibri, Calibri_EmbeddedFont, Calibri_MSFontService, sans-serif; color: rgb(0, 0, 0); font-size: 11pt;"><br></span></p>
        ${commonTableHTMLRP}
      </div>`

    const isReceivableOrPayableFinancing = ["Receivable Financing", "Payable Financing"].includes(dealDetails.dealProductCommercials[0]?.product);

    setTemplate(!isReceivableOrPayableFinancing ? initialHtmlWC : initialHtmlRP);
  }, [dealDetails]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: dealId || "",
      termsheet: content,
    },
    onSubmit: (values) => {
      setConfirmLoading(true);
      if (camData.length > 0) {
        const entity = {
          aboutSection: camData[0]?.aboutSection,
          directorSharehodlerList: camData[0]?.directorSharehodlerList,
          keyStrength: camData[0]?.keyStrength,
          finSummary: camData[0]?.finSummary,
          debtProfile: camData[0]?.debtProfile,
          customerSupplier: camData[0]?.customerSupplier,
          termsheet: values.termsheet,
          entityId: entityId,
          dealId: dealId,
          id: camData[0]?.id,
          lastVisitedStep: "cam-preview" || null,
        }
        editCamData(entity)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Cam Data Updated",
                showToast: true,
                role: "success",
              });
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        const entity = {
          aboutSection: camData[0]?.aboutSection,
          directorSharehodlerList: camData[0]?.directorSharehodlerList,
          keyStrength: camData[0]?.keyStrength,
          finSummary: camData[0]?.finSummary,
          debtProfile: camData[0]?.debtProfile,
          customerSupplier: camData[0]?.customerSupplier,
          termsheet: values.termsheet,
          entityId: entityId,
          dealId: dealId,
          id: camData[0]?.id,
          lastVisitedStep: "cam-preview" || null,
        };
        addCamData(entity)
          .then((response) => {
            if (response.code == 201 && response.status) {
              setToastInfo({
                message: "Cam Data Saved",
                showToast: true,
                role: "success",
              });
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  });

  useImperativeHandle(ref, () => ({
    handleSubmit: () => validation.handleSubmit(),
    getValidationStatus: () =>
      validation.validateForm().then((errors) => Object.keys(errors).length === 0),
  }));

  const generateTableRows = (fields) => {
    return fields.map(field => `
      <tr>
        <td style='border:1px solid black; padding: 4px; font-size: 12px; font-weight:700; width: 50%'>${field.title}</td>
        <td style='border:1px solid black; padding: 4px; font-size: 12px; width: 50%;'>
         </td>
      </tr>
    `).join('');
  };

  const fields = [
    { title: "Facility" },
    { title: "Limit" },
    { title: "Tenor" },
    { title: "PF" },
    { title: "Proposal Type" },
    { title: "ROI" },
    { title: "Collateral / Security" },
    { title: "Co-Borrower / Guarantor" }
  ];
  const fieldsRP = [
    { title: "Facility" },
    { title: "Name of the Anchor Company" },
    { title: "Borrower" },
    { title: "Purpose" },
    { title: "Loan Amount Requested" },
    { title: "Proposal Type" },
    { title: "Interest" },
    { title: "Margin" },
    { title: "Security" },
    { title: "Facility Limit to Anchor" },
    { title: "Interest Rate" },
    { title: "Processing Fee" },
    { title: "Tenure" },
    { title: "Invoice stale period" },
    { title: "Proposed Repayment" }
  ];

  const commonTableHTML = `
    <table id="supplierTable" border="1" style="border-collapse: collapse; width: 100%; font-size: 12px; margin-top: 10px">
      <thead>
        <th style="border: 1px solid #000; padding: 8px;font-size: 12px">Title</th>
        <th style="border: 1px solid #000; padding: 8px;font-size: 12px">Value</th>
      </thead>
      <tbody>
        ${generateTableRows(fields)}
      </tbody>
    </table>
  `;
  const commonTableHTMLRP = `
    <table id="supplierTable" border="1" style="border-collapse: collapse; width: 100%; font-size: 12px; margin-top: 10px">
      <thead>
        <th style="border: 1px solid #000; padding: 8px;font-size: 12px">Title</th>
        <th style="border: 1px solid #000; padding: 8px;font-size: 12px">Value</th>
      </thead>
      <tbody>
        ${generateTableRows(fieldsRP)}
      </tbody>
    </table>
  `;


  const navigateBack = () => {
    navigate(-1);
  };

  const config = {
    removeButtons: ['about'],
    showCharsCounter: false,
    showWordsCounter: false,
    showXPathInStatusbar: false,
  };



  const handleToast = (info) => {
    setToastInfo(info);
  };

  return (
    <React.Fragment>
      <Row className="mb-4">
        <Col xs="12">
          <FormikProvider value={validation}>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <Row>
                <Col sm={12}>
                  <JoditEditor
                    ref={editor}
                    value={content}
                    config={config}
                    onBlur={(newContent) => {
                      setContent(newContent);
                    }}
                  />
                </Col>
              </Row>
            </Form>
          </FormikProvider>

        </Col>
      </Row>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
    </React.Fragment>
  );
});


EntityTermsheet.propTypes = {
  history: PropTypes.object,
};

EntityTermsheet.displayName = "EntityTermsheet"
export default EntityTermsheet;


